// Own attribution search params
export enum OwnAttributionSearchParams {
  utmSource = 'utm_source',
  utmMedium = 'utm_medium',
  utmCampaign = 'utm_campaign',
  utmContent = 'utm_content',
  source = 'source',
}
